import React from "react";

const COLOR_MAP = {
  rojo: "#E10600",
  blanco: "#FFFFFF",
  gris: "#9CA3AF",
  "gris claro": "#D1D5DB",
  "gris oscuro": "#4B5563",
  negro: "#111111",
  azul: "#2563EB",
  "azul oscuro": "#1E40AF",
  "azul claro": "#60A5FA",
  verde: "#16A34A",
  amarillo: "#EAB308",
  naranja: "#F97316",
  marron: "#78350F",
  marrón: "#78350F",
  beige: "#D6C39C",
  plata: "#C0C0C0",
  plateado: "#C0C0C0",
  dorado: "#D4AF37",
  violeta: "#7C3AED",
  rosa: "#EC4899",
};

export function resolveSwatchColor(name) {
  if (!name) return "#9CA3AF";
  const key = String(name).trim().toLowerCase();
  return COLOR_MAP[key] || "#6B7280";
}

export default function ColorSwatch({ color, size = 12, className = "", testId }) {
  if (!color) return null;
  const bg = resolveSwatchColor(color);
  return (
    <span
      title={color}
      aria-label={`Color ${color}`}
      data-testid={testId}
      className={`inline-block rounded-full border border-neutral-400 shadow-sm ${className}`}
      style={{ width: size, height: size, backgroundColor: bg }}
    />
  );
}
